<template>
  <div class="menber-dialog">
    <el-dialog
      title="需求信息详情"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="600px"
    >
    <el-form :inline="true" label-width="150px">
        <el-form-item label="托管人:" style="width: 220px;">
          {{ currentItem.farmerName }}
        </el-form-item>
        <el-form-item label="托管人电话:">
          {{ currentItem.farmerPhone }}
        </el-form-item>
    </el-form>
      <el-form ref="form" label-width="150px">
        <el-form-item label="托管时间:">
          {{ currentItem.startDate }}-{{ currentItem.endDate }}
        </el-form-item>
        <el-form-item label="已推送农服商:">
          {{ currentItem.pushCompanyName}}
        </el-form-item>

        <el-form-item label="托管类型:">
          {{ currentItem.orderType == 1 ? "全程托管" : "环节托管" }}
        </el-form-item>
        <el-form-item label="种养品种:">
          {{ currentItem.cropCode}}
        </el-form-item>
        <el-form-item label="农事类型:">
          {{ currentItem.orderContent}}
        </el-form-item>
        <el-form-item label="每季保底产量:">
          {{ currentItem.seasonYield }}亩
        </el-form-item>
        <el-form-item label="单价:">
          {{ currentItem.univalentPrice }}元
        </el-form-item>
        <el-form-item label="土地面积:">
          {{ currentItem.landArea }}亩
        </el-form-item>
        <el-form-item label="总价:">
          {{ currentItem.estimatePrice }}元
        </el-form-item>
        <el-form-item label="地址:">
          {{ currentItem.areaName }}
        </el-form-item>
        <el-form-item label="其他说明:">
          {{ currentItem.remark }}
        </el-form-item>
        <el-form-item label="现场照片:">
          <el-image
            style="width: 100px; height: 100px ; margin-right:5px"
            :src="item"
            v-for="(item, index) in currentItem.xczp"
            :key="index"
            :preview-src-list="currentItem.xczp"
          >
          </el-image>
        </el-form-item>
      </el-form>
      <div class="btns"><el-button size="small" type="info" @click="back">关闭</el-button><el-button size="small" type="primary" @click="tuisong">推送</el-button></div>
    </el-dialog>
  </div>
</template>
  <script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      dialogVisible: true,
      baseUrl: window.globalUrl.HOME_API,
      currentItem: {},
    };
  },
  mounted() {},
  computed: mapGetters(["userInfo"]),
  watch: {},
  methods: {
    // 推送
    tuisong(){
      this.$parent.push(this.currentItem);
    },
    // 初始化 构造回显的详情
    init(obj) {
      let xczp = [];
      if (obj.livePhotos) {
        JSON.parse(obj.livePhotos).forEach((item) => {
          xczp.push(this.baseUrl + "admin/file/get?ossFilePath=" + item.url );
        });
      }
      obj.xczp = xczp;
      this.currentItem = obj;
    },
    // 返回
    back() {
      this.$emit("closeDialog2", false);
    },
    // 关弹窗
    handleClose() {
      this.$emit("closeDialog2", false);
    },
  },
};
</script>
  <style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0 !important;
  .el-input {
    width: 260px;
  }
}
/deep/.el-dialog__body {
  padding-left: 30px;
}
.btns{
  display: flex;
  margin-top: 20px;
  justify-content: space-around;
}
</style>
